import React from "react";
import { slugify } from "./searchIndex";

interface SettingsCardProps {
  title:        string;
  subtitle?:    string;
  icon?:        React.ReactNode;
  headerRight?: React.ReactNode;   // optional slot for right side of header row
  children:     React.ReactNode;
  footer?:      React.ReactNode;
  id?:          string;            // override the auto anchor (defaults to slug of title)
  bordered?:    boolean;           // prominent outline + shadow so adjacent cards read as separate panels
}

export const SettingsCard: React.FC<SettingsCardProps> = ({
  title,
  subtitle,
  icon,
  headerRight,
  children,
  footer,
  id,
  bordered = false,
}) => (
  // id + scroll-mt let the settings search scroll this card under the sticky header.
  <div id={id ?? slugify(title)} className={`bg-white rounded-2xl p-6 scroll-mt-6 transition-shadow ${bordered ? "border-2 border-gray-300 shadow-md" : ""}`}>
    <div className="flex items-center justify-between gap-3 mb-5">
      <div className="flex items-center gap-3">
        {icon && (
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-cyan-400 to-blue-500 flex items-center justify-center text-white flex-shrink-0">
            {icon}
          </div>
        )}
        <div>
          <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
          {subtitle && (
            <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>
          )}
        </div>
      </div>
      {headerRight && <div className="flex-shrink-0">{headerRight}</div>}
    </div>

    <div>{children}</div>

    {footer && (
      <div className="mt-5 pt-4 border-t border-gray-100">
        {footer}
      </div>
    )}
  </div>
);
